import {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from "react";
import { useNavigate } from "react-router-dom";
import axios from "../customAxios";
import AuthService from "../services/AuthService";

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [messageAlert, setMessageAlert] = useState("");
  const [openAlert, setOpenAlert] = useState(false);
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem("user");
    return savedUser ? JSON.parse(savedUser) : null;
  });

  const login = async (email, password) => {
    try {
      setIsLoading(true);
      const { data, status } = await axios.post("login/", {
        email: email,
        password: password,
      });
      if (status !== 200) {
        throw new Error(data);
      }
      localStorage.setItem("user", JSON.stringify(data));
      setUser(data);
      if (data?.user_type.includes("driver")) {
        navigate("/driver/my-routes");
      } else if (data?.admin_plan?.plan_type === "admin_checkout") {
        navigate("/admin_checkout/delivery-resume");
      } else {
        navigate("/home/dashboard");
      }
    } catch (error) {
      console.log(error);
      if (error?.response) {
        setMessageAlert("Credenciales Inválidas");
      } else {
        setMessageAlert("Hubo un error al iniciar sesión");
      }
      setOpenAlert(true);
    } finally {
      setIsLoading(false);
    }
  };

  const logoutLocal = useCallback(async () => {
    localStorage.clear();
    setUser(null);
    navigate("/");
    console.info("Logout local completado");
  }, [navigate]);

  const logout = useCallback(async () => {
    logoutLocal();
    try {
      await axios.post("/logout/", null);
    } catch (error) {
      console.error(
        "Fallo al desloguear en el backend (el usuario ya fue deslogueado en el frontend):",
        error
      );
    }
  }, [navigate, logoutLocal]);

  useEffect(() => {
    AuthService.register(logout);
  }, [logout]);

  useEffect(() => {
    try {
      const savedUser = localStorage.getItem("user");
      if (savedUser) setUser(JSON.parse(savedUser));
    } finally {
      setIsLoading(false);
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        logout,
        logoutLocal,
        messageAlert,
        openAlert,
        setOpenAlert,
        isLoading,
        setIsLoading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
